<template>
    <section v-if="caseItem" class="detail nunito">
        <div class="content">
            <div class="row">
                <div class="info">
                    <h1>{{ caseItem.title }}</h1>
                </div>
                <div class="media">
                    <swiper @autoplayTimeLeft="onAutoplayTimeLeft" :autoplay="{
                        delay: 10000,
                        disableOnInteraction: true,
                    }" :cssMode="true" :navigation="true" :pagination="true" :mousewheel="true" :keyboard="true"
                        :modules="modules" class="mySwiper">
                        <swiper-slide><img :src="caseItem.coverImage" :alt="caseItem.title" :title="caseItem.title" /></swiper-slide>
                        <swiper-slide v-for="(media, index) of caseItem.media" :key="index"><img :src="media.url"
                                :alt="caseItem.title + ' ' + index" :title="caseItem.title + ' ' + index" /></swiper-slide>
                    </swiper>
                    <p>{{ caseItem.description }}</p>
                    <div class="date" v-if="caseItem.date">
                        <i class="fa-regular fa-clock"></i>
                        <span>{{ formatDate(caseItem.date) }}</span>
                    </div>
                </div>

            </div>
        </div>
    </section>
    <div class="" v-else>
        <h2>No se pudo encontrar ese artículo</h2>
    </div>
</template>

<script>
import casesData from '../data/blogs.json';
import { Swiper, SwiperSlide } from 'swiper/vue';
import moment from 'moment';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

import 'moment/locale/es';
moment.locale('es');

export default {
    name: 'CaseDetailPage',
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            caseItem: null,
            modules: [Autoplay, Navigation, Pagination, Mousewheel, Keyboard],
        };
    },
    mounted() {
        const titleSlug = this.$route.params.title;
        this.caseItem = casesData.find(item => this.toSlug(item.title) === titleSlug);
    },
    methods: {
        toSlug(text) {
            return text
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-z0-9\s-]/g, '')
                .trim()
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-');
        },
        formatDate(dateString) {
            return moment(dateString, 'YYYY-MM-DD h:mm A').fromNow();
        }
    }
};
</script>

<style scoped lang="scss">
section.detail {
    width: 100%;
    margin: 40px 0;

    .content {
        max-width: 1280px;
        margin: 0 auto;

        .row {
            width: 90%;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            gap: 20px;

            .media {
                flex: 1;
                width:100%;
                .mySwiper {
                    .swiper-slide {
                        height:300px;
                        position: relative;
                        img {
                            position: absolute;
                            left: 0;
                            top:0;
                            width: 100%;
                            height:auto;
                            object-fit: cover;
                        }
                    }
                }
            }

            p {
                margin-top: 20px;
            }

            .date {
                display: flex;
                gap: 5px;
                font-size: 1.2rem;
                align-items: center;
            }

            .info {
                flex:1;
                text-align:center;
                h1 {
                    text-align:center;
                    font-size: 3rem;
                }

            }
        }
    }
}
</style>